import { checkEmploymentGapsAndOverlaps } from "score-check/utils/checkEmploymentGapsOverlaps";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getMistakesInStatement } from "../statment-analysis-scoring/countMistakesInStatement";
import { WorkExperienceScoreAnalysis } from "../types";
import { calculateWordCount } from "../content-details-sections/word-count";


export const getExperienceScore = (experiences: ResumeAnalysis["workExperiences"], maxScoreOfSection: number): WorkExperienceScoreAnalysis => {
  if (experiences.individualWorkExperiencesAnalysis.length === 0) {
    return {
      totalScore: 0,
      statementMistakeCount: 0,
      informationMistakeCount: 0,
      gap: 0,
      overlap: 0,
      totalMistakeCount: 0
    };
  }
  let statementMistakeCount = 0;
  let informationMistakeCount = 0;
  let gap = 0;
  let overlap = 0
  let totalMistakeCount = 0;
  const { gaps, overlaps } = checkEmploymentGapsAndOverlaps(experiences.individualWorkExperiencesAnalysis)

  experiences.individualWorkExperiencesAnalysis.forEach((exp) => {
    if (!exp.startDate && !exp.endDate) {
      informationMistakeCount++;
    }
    if (!exp.company) {
      informationMistakeCount++;
    }
    if (!exp.role) {
      informationMistakeCount++;
    }
    // if (!exp.descriptionAnalysis.find(desc => desc.analysis.gapInEmployment !== 1)) {
    //   gap++
    // }
    // if (!exp.descriptionAnalysis.find(desc => desc.analysis.overlapInEmployment !== 1)) {
    //   overlap++
    // }
    if (!exp.descriptionAnalysis.find(desc => desc.analysis.isQuantified === 1)) {
      statementMistakeCount++;
    }
    if (!exp.descriptionAnalysis.find(desc => desc.analysis.reverseOrder !== 1)) {
      statementMistakeCount++;
    }
    if (exp.descriptionAnalysis.length > 0) {
      exp.descriptionAnalysis.forEach((desc) => {
        statementMistakeCount += getMistakesInStatement(desc.analysis);
      })
    }
    if (exp.descriptionAnalysis.length < 2) statementMistakeCount++;
    const longSentences = exp.descriptionAnalysis
      .filter(desc => calculateWordCount(desc.statement) > 25)
      .map(desc => desc.statement);
    statementMistakeCount += longSentences.length;
  })
  if (gaps.length > 0) {
    gap += gaps.length;
  }
  if (overlaps.length > 0) {
    overlap += overlaps.length;
  }

  let totalScore = maxScoreOfSection;
  totalMistakeCount = statementMistakeCount + informationMistakeCount
  if (totalMistakeCount > 0 && totalMistakeCount <= 3) {
    totalScore -= 0.1 * maxScoreOfSection;
  } else if (totalMistakeCount > 3 && totalMistakeCount <= 6) {
    totalScore -= 0.25 * maxScoreOfSection;
  } else if (totalMistakeCount > 6 && totalMistakeCount <= 12) {
    totalScore -= 0.4 * maxScoreOfSection;
  } else if (totalMistakeCount > 12 && totalMistakeCount <= 18) {
    totalScore -= 0.6 * maxScoreOfSection;
  } else if (totalMistakeCount > 18) {
    totalScore -= 0.8 * maxScoreOfSection;
  }

  return {
    totalScore,
    statementMistakeCount,
    informationMistakeCount,
    gap,
    overlap,
    totalMistakeCount
  };
}
